/**
 * @file: sentry.shared.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { getApplicationIdentifier } from '@euler/config';
import { kAppVersion, kAppVersionCode } from '@euler/config/app-info';

export function getSentryRelease() {
  const appId = getApplicationIdentifier();

  // see the following link for canonic sentry release name convention:
  // https://docs.sentry.io/product/cli/releases/
  return `${appId}@${kAppVersion}+${kAppVersionCode}`;
}

export function getSentryDistribution() {
  return `${kAppVersionCode}`;
}
